document.addEventListener("DOMContentLoaded", function () {
  loadLoader();
});

document.addEventListener("shopify:section:load", function () {
  loadLoader();
});

function loadLoader() {
  const countCards = document.querySelectorAll(
    ".proven_banner_section .count_card"
  );

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const card = entry.target;
          const heading = card.querySelector(".heading");
          const textContent = heading.textContent;
          const countValue = heading.getAttribute("data-count");
          let currentCount = 0;

          const intervalId = setInterval(() => {
            if (currentCount < countValue) {
              currentCount += 1;
              heading.textContent = currentCount;
            } else {
              clearInterval(intervalId);
              heading.textContent = textContent;
            }
          }, 10);
        }
      });
    },
    {
      threshold: 0.1,
      rootMargin: "0px",
    }
  );

  // Start observing each count card
  countCards.forEach((card) => {
    observer.observe(card);
  });

  const faqCards = document.querySelectorAll(".benifit_section .benifit_card");

  faqCards.forEach((card) => {
    const btn = card.querySelector(".pf_button");
    btn.addEventListener("click", () => {
      faqCards.forEach((elm) => elm !== card && elm.classList.remove("active"));
      card.classList.toggle("active");
    });
  });


  new Swiper('.image_grid_slider', {
    slidesPerView: 1,
    pagination: {
      el: '.swiper-pagination',
    },
  });

  new Swiper(".pf-reviews-gallery", {
    slidesPerView: "auto",
    spaceBetween: 4,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    loop: true,
    speed: 3000,
  });

  new Swiper(".pf-reviews-slider", {
    slidesPerView: 1.05,
    spaceBetween: 8,
    pagination: {
      el: ".pf-reviews-pagination",
      type: "progressbar",
    },
    navigation: {
      nextEl: ".pf-reviews-next",
      prevEl: ".pf-reviews-prev",
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 14,
      },
      992: {
        slidesPerView: 3,
      },
    },
  });
}
